export default __webpack_public_path__ + "static/illustration-p3-17fec77a49a5b19b00833c30acec0063.gif";